import { useState } from 'react'
import RotaTable, { SortObject } from '../components/RotaTable'
import styled from 'styled-components'
import RotaFilters, {
  RotaFiltersValue,
} from '../RotaBuilder/common/components/RotaFilters'
import { useRotaPatternsList } from '../hooks/useRotaPatternsList'
import { SHIFT } from '../constants'

const RotaShiftsTable = () => {
  const [sortParams, setSortParams] = useState<SortObject>({
    field: 'instanceType',
    order: 'ascend',
  })
  const [filterParams, setFilterParams] = useState<RotaFiltersValue>({})

  const { patternList, isLoadingList, pagination, setPage } =
    useRotaPatternsList({
      type: SHIFT,
      patternListSorting: sortParams,
      patternListFilters: filterParams,
    })

  const onFilterChange = (value: RotaFiltersValue) => {
    setFilterParams((prevFilters) => ({
      ...prevFilters,
      ...value,
    }))
  }

  return (
    <Container>
      <RotaFilters
        value={filterParams}
        onChange={onFilterChange}
        hasResidentsFilter={false}
        filtersType="shift"
      />
      <RotaTable
        tableType="shift"
        patternList={patternList}
        isLoading={isLoadingList}
        pagination={pagination}
        onChange={(page) => setPage(page)}
        onSortChange={setSortParams}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export default RotaShiftsTable
